import React from "react"

export default function Blog030() {
  return (
    <section>
    <article>
    <h2>30. 12-26-2022</h2>
          <h3>Excited to announce my new Job</h3>
          <p>
          <strong>Hello everyone,</strong>
          <br /><br />
        

      
I am excited to announce that I have recently been hired as a software engineer at In The Zone! As a software developer, I am always looking for opportunities to grow and improve my skills, and I am thrilled to have the opportunity to do just that at In The Zone.
<br /><br />
One of the things that I am most excited about in my new position is the opportunity to work with such a talented team of developers. In The Zone has a reputation for hiring some of the best and brightest in the industry, and I am excited to learn from my colleagues and contribute to the company's success.
<br /><br />
In addition to my work at In The Zone, I have also been busy working on a personal project of mine - a fake news website called Bahagafish News. This website is a comedy, fictional blog news website that I created for fun. I have been having a lot of fun working on this project, and I am excited to see where it takes me.
<br /><br />
One of the things that I have been focusing on with Bahagafish News is using Google Analytics to track the website's traffic and performance. I have also been using react.js and Helmet to manage the website's meta data, and firebase auth to ensure secure user authentication. These tools have been incredibly useful in helping me to improve the website and make it as user-friendly as possible.
<br /><br />
Overall, I am having a great time working on both my professional and personal projects. I am excited to see what the future holds and to continue learning and growing as a software engineer. Thank you for reading!
<br /><br />
Sincerely,<br />
Eric Polley
<br />





         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="http://news.ericpolley.com/"
              title="BAHAGAFISH!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>BAHAGAFISH NEWS</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
